import { Fragment, h } from 'preact';
import { useContext } from 'preact/hooks';
import classNames from 'classnames';
import { KBContext, NavigationContext } from 'widget_main/store';
import {
  CONVERSATIONS_PATH,
  MESSAGE_THREAD_PATH,
  MODAL_ROOT_ID,
  KB_SEARCH_PATH,
  KB_ARTICLE_PATH,
  KB_DEFLECT_ARTICLE_PATH,
} from 'widget_main/globals/constants';

import ErrorBoundary from 'widget_main/components/ErrorBoundary';
import TitleBarButtons from '../Header/TitleBarButtons';
import ConversationsHeader from '../Header/ConversationsHeader';
import MessageThreadHeader from '../Header/MessageThreadHeader';
import Conversations from '../Conversations';
import MessageThread from '../MessageThread';
import KBSearchList from '../KBSearchList';
import Footer from '../Footer';
import styles from './widget.scss';
import KBHeader from '../Header/KBHeader';
import KBArticle from '../KBArticle/KBArticle';

interface WidgetProps {
  isMobile: boolean;
}

const Widget = ({ isMobile }: WidgetProps) => {
  const navigationState = useContext(NavigationContext);
  const kb = useContext(KBContext);

  const renderHeader = () => {
    switch (navigationState.page) {
      case CONVERSATIONS_PATH:
        return (
          <Fragment>
            <TitleBarButtons />
            <ConversationsHeader />
          </Fragment>
        );
      case MESSAGE_THREAD_PATH:
        return (
          <Fragment>
            <TitleBarButtons
              onGoBack={() => {
                navigationState.updatePage(CONVERSATIONS_PATH);
              }}
            />
            <MessageThreadHeader />
          </Fragment>
        );
      case KB_SEARCH_PATH: {
        const { currentCategoryId } = kb;

        let onGoBack;

        if (currentCategoryId) {
          const category = kb.categories?.[currentCategoryId];
          const parent = category?.parentCategory;
          onGoBack = parent
            ? () => kb.updateCurrentCategoryId(parent)
            : undefined;
        }

        return (
          <Fragment>
            <TitleBarButtons onGoBack={onGoBack} />
            <KBHeader />
          </Fragment>
        );
      }
      case KB_ARTICLE_PATH: {
        return (
          <Fragment>
            <TitleBarButtons
              onGoBack={() => {
                navigationState.updatePage(KB_SEARCH_PATH);
              }}
            />
            <KBHeader />
          </Fragment>
        );
      }
      case KB_DEFLECT_ARTICLE_PATH: {
        return (
          <Fragment>
            <TitleBarButtons
              onGoBack={() => {
                navigationState.updatePage(MESSAGE_THREAD_PATH);
              }}
            />
            <KBHeader />
          </Fragment>
        );
      }
      default:
        return (
          <Fragment>
            <TitleBarButtons />
            <ConversationsHeader />
          </Fragment>
        );
    }
  };

  const routeWithErrorBoundary = (node) => {
    return <ErrorBoundary page={navigationState.page}>{node}</ErrorBoundary>;
  };

  const renderRoute = () => {
    switch (navigationState.page) {
      case CONVERSATIONS_PATH:
        return routeWithErrorBoundary(<Conversations />);
      case MESSAGE_THREAD_PATH:
        return routeWithErrorBoundary(<MessageThread />);
      case KB_SEARCH_PATH:
        return routeWithErrorBoundary(<KBSearchList />);
      case KB_ARTICLE_PATH:
        return routeWithErrorBoundary(<KBArticle />);
      case KB_DEFLECT_ARTICLE_PATH:
        return routeWithErrorBoundary(<KBArticle />);
      default:
        return routeWithErrorBoundary(<Conversations />);
    }
  };

  return (
    <div
      class={classNames(styles.widgetWrapper, {
        [styles.mobile]: isMobile,
      })}
    >
      <div class={styles.widget}>
        {renderHeader()}
        <div id={MODAL_ROOT_ID} className={styles.modalContainer}>
          {renderRoute()}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Widget;
